import { MapContainer, TileLayer, Marker, Polyline, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";

const PARIS_TX = [33.6609, -95.5555];
const ROUTE_PATH_OPTIONS = { color: "#F97316", weight: 5, opacity: 0.85 };
const FIT_BOUNDS_OPTIONS = { padding: [50, 50], maxZoom: 12 };

function numberIcon(label, isPickup) {
  return L.divIcon({
    html: `<div class="kg-marker ${isPickup ? "pickup" : ""}">${label}</div>`,
    className: "",
    iconSize: [30, 30],
    iconAnchor: [15, 15],
  });
}

function previewIcon() {
  return L.divIcon({
    html: `<div class="kg-marker" style="background:#fff;color:#EA580C;border:2px dashed #F97316;">📍</div>`,
    className: "",
    iconSize: [30, 30],
    iconAnchor: [15, 15],
  });
}

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points && points.length) {
      const bounds = L.latLngBounds(points.map((p) => [p.lat, p.lon]));
      map.fitBounds(bounds, FIT_BOUNDS_OPTIONS);
    }
  }, [points, map]);
  return null;
}

export default function MapView({ points, geometry, previewPoints = [] }) {
  const hasData = points && points.length > 0;
  // Fit to route points when calculated, otherwise to any preview pins.
  const fitPoints = hasData ? points : previewPoints;
  return (
    <div className="h-full w-full" data-testid="route-map">
      <MapContainer
        center={PARIS_TX}
        zoom={9}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {geometry && geometry.length > 1 && (
          <Polyline positions={geometry} pathOptions={ROUTE_PATH_OPTIONS} />
        )}
        {hasData &&
          points.map((p, idx) => (
            <Marker
              key={`${p.lat},${p.lon},${idx === 0 ? "pickup" : p.address}`}
              position={[p.lat, p.lon]}
              icon={numberIcon(idx === 0 ? "P" : String(idx), idx === 0)}
            >
              <Popup>
                <b>{idx === 0 ? "Pickup" : `Stop ${idx}`}</b>
                <br />
                {p.address}
              </Popup>
            </Marker>
          ))}
        {!hasData &&
          previewPoints.map((p) => (
            <Marker key={`preview-${p.lat},${p.lon}`} position={[p.lat, p.lon]} icon={previewIcon()}>
              <Popup>
                <b>Pin preview</b>
                <br />
                {p.label}
              </Popup>
            </Marker>
          ))}
        {fitPoints && fitPoints.length > 0 && <FitBounds points={fitPoints} />}
      </MapContainer>
    </div>
  );
}
